import { Background } from "./Background";
import { AppFrame } from "./AppFrame";
import { LoadingOverlay } from "./LoadingOverlay";
import { useIsAuthenticated } from "services/auth/AuthService";
import { useConnectionStateManager } from "../services/FetchUtils";
import { DisconnectionOverlay } from "./DisconnectionOverlay";
import { TfidHighlightProvider } from "utils/TfidHighlightProvider";

export const AppView = () => {
  const isAuthenticated = useIsAuthenticated();
  const [isConnected] = useConnectionStateManager();

  return (
    <TfidHighlightProvider>
      <>
        <Background blur="20px" opacity="25%" zIndex={-1} />
        <AppFrame />
        {!isAuthenticated && <LoadingOverlay />}
        {!isConnected && <DisconnectionOverlay />}
      </>
    </TfidHighlightProvider>
  );
};
